import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(() => ({
    active: { backgroundColor: '#007DC5', color: '#FFFFFF' },
    button: { width: 'fit-content', border: '1px solid #007DC5', padding: 10, cursor: 'pointer' },
    leftButton: { borderRadius: '5px 0 0 0' },
    rightButton: { borderRadius: '0 5px 0 0' },
    table: {
        width: '100%',
        tableLayout: 'fixed',
        borderCollapse: 'collapse',
        maxWidth: 1100,
        '& td, & th': {
            padding: '10px 10px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            borderBottom: '1px solid #CCCCCC',
        },
        '& tr': {
            '&:last-child': {
                '& td': { borderBottom: 'none' },
            },
        },
        '& th': {
            paddingTop: 3,
            paddingBottom: 7,
            fontWeight: 'normal',
            color: '#666666',
            borderBottom: '1px solid #007DC5',
        },
        '& span': { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' },
        position: 'relative',
        '& th, & td, & span': { fontSize: 12 },
    },
    tabs: {
        position: 'absolute',
        top: '-2px',
        left: 0,
        height: 50,
        '& span': { fontSize: 12 },
    },
    tableHeader: {
        '& th': {
            height: 33,
            '&:last-child': {
                height: 34,
            },
        },
    },
    description: {
        color: '#4D4D4D',
        textDecoration: 'underline',
        cursor: 'pointer',
        '@media(max-width: 1200px)': {
            width: 140,
        },
    },
    status: { color: '#3C8401', textAlign: 'left' },
    action: {
        color: '#276700',
        fontWeight: 'bold',
        textTransform: 'capitalize',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    delay: {
        minWidth: 150,
        '& span': { color: '#666666' },
        '@media(max-width: 1200px)': {
            width: 140,
        },
    },
    alertsWrapper: { height: '100%', display: 'flex' },
    alignRight: {
        textAlign: 'right',
    },
    alignLeft: { textAlign: 'left' },
}));
//# sourceMappingURL=styles.js.map